<template>
  <q-page class="bg-white">
    <q-card class="my-card" flat>
      <q-img
        :src="configTemplate_mainBackground"
        placeholder-src="hero-results-compressed-small.jpg"
        no-spinner
        alt=""
        height="250px">
        <div class="hero fit col wrap justify-center items-center content-center text-blur">

          <q-skeleton v-if="timetable === null" type="text" tag="div" style="width: 50%; height: 5vh" animation="fade"></q-skeleton>
          <div v-else class="text-h1 text-center text-primary font-title">{{ eventName }}</div>

          <q-skeleton v-if="timetable === null" type="text" tag="div" style="width: 30%; height: 3vh" animation="fade"></q-skeleton>
          <div v-else class="text-h5 text-center">{{ organizerName }}</div>

          <q-skeleton v-if="timetable === null" type="text" tag="div" style="width: 70%; height: 3vh" animation="fade"></q-skeleton>
          <div v-else class="text-h6 text-center">{{ $t('live.timetable.show') }} {{timetable.show.number}} - {{timetable.show.name}}</div>
        </div>
      </q-img>
    </q-card>


    <div class="q-pa-md-md q-pa-sm q-pb-xl ios-mobile">

      <!-- documents link -->
      <div class="full-width row wrap justify-between q-mb-md bg-grey-4 q-pa-xs" style="border-radius: 20px">
        <q-btn rounded no-caps color="primary" icon="fa-solid fa-caret-left" size="sm" :label="$t('live.timetable.back')" :to="{name: 'LiveTimetable', params: {event_id: $route.params.event_id, number:$route.params.number}}" />
      </div>
      <!-- end document link -->

      <div class="full-width row items-center content-center">

        <!-- no timetable -->
        <div v-if="timetable && timetable.timetable.length === 0" class="fit column wrap text-center justify-center items-center content-center">
          <q-icon name="fa-light fa-file-alt" class="q-mt-lg" size="xl"></q-icon><br />
          {{ $t('live.timetable.no-timetable') }}
        </div>

        <div v-else-if="timetable && timetable.timetable !== [] && zone !== null && zone !== undefined" class="col-12">

          <q-list class="col-12 q-mb-lg">

            <q-expansion-item
              dark :default-opened="true"
              style="background-color: var(--q-primary); border-top-left-radius: 5px; border-top-right-radius: 5px"
              expand-separator
              expand-icon="none"
              icon="fa fa-file-alt"
              :label="formatDate($route.params.date) + ' - ' + zone.name"
              :caption="$t('live.timetable.last-update') + ' : ' + formatDateFull(zone.updated_at)"
            >
              <q-card>
                <q-card-section class="q-pa-none">

                  <div v-for="(horaire, indexHoraire) in zone.timetable" :key="`timetable-horaire-${indexHoraire}`" :class="horaire.___line_type === 'break' && 'break'">
                    <q-item v-if="horaire.___line_type !== 'break'" :class="indexHoraire%2 === 0 && 'line-even'">
                      <q-item-section avatar>
                        <q-avatar color="secondary" rounded font-size="16px">
                          {{ horaire.cavalier_startlist }}
                        </q-avatar>
                      </q-item-section>
                      <q-item-section avatar>
                        <q-avatar color="primary" text-color="white" font-size="12px" v-if="timetable.federation === 'fei'">
                          {{ horaire.tours_dossard_ffe }}
                        </q-avatar>
                        <q-avatar color="primary" text-color="white" font-size="16px" v-else>
                          {{ horaire.tours_dossard }}
                        </q-avatar>
                      </q-item-section>

                      <q-item-section top>
                        <q-item-label lines="1">
                          <span class="text-weight-medium">{{ horaire.tours_cheval }}</span>
                        </q-item-label>
                        <q-item-label caption lines="1">
                          <span><country-flag :country="horaire.flag" v-if="timetable.federation === 'fei'" size='small'/> {{ capitalize(horaire.tours_prenom) }} {{ horaire.tours_nom.toUpperCase() }}</span>
                        </q-item-label>
                      </q-item-section>

                      <q-item-section side>
                        <div class="q-gutter-xs text-weight-bold text-primary">
                          <span v-if="zone.mode === 'timetable' || indexHoraire === 0">{{ formatHour(horaire.cavalier_heure) }}</span>
                          <span v-else>-</span>
                        </div>
                      </q-item-section>
                    </q-item>

                    <!-- pause -->
                    <q-item v-ripple v-if="horaire.___line_type === 'break'" style="background-color: var(--q-primary);">

                      <q-item-section avatar>
                        <q-avatar color="white" text-color="primary" icon="fa fa-pause"></q-avatar>
                      </q-item-section>

                      <q-item-section>
                        <q-item-label caption class="text-center text-white">
                          <span class="text-weight-medium">{{ horaire.___line_value }}</span>
                        </q-item-label>
                      </q-item-section>
                    </q-item>
                  </div>

                </q-card-section>
              </q-card>
            </q-expansion-item>

          </q-list>
        </div>

        <!-- loader -->
        <div v-else class="col-12">
          <div class="q-pa-md">
            <q-item>
              <q-item-section avatar>
                <q-skeleton type="QAvatar" />
              </q-item-section>

              <q-item-section>
                <q-item-label>
                  <q-skeleton type="text" />
                </q-item-label>
                <q-item-label caption>
                  <q-skeleton type="text" width="65%" />
                </q-item-label>
              </q-item-section>
            </q-item>

            <q-item>
              <q-item-section avatar>
                <q-skeleton type="QAvatar" />
              </q-item-section>

              <q-item-section>
                <q-item-label>
                  <q-skeleton type="text" />
                </q-item-label>
                <q-item-label caption>
                  <q-skeleton type="text" width="90%" />
                </q-item-label>
              </q-item-section>
            </q-item>

            <q-item>
              <q-item-section avatar>
                <q-skeleton type="QAvatar" />
              </q-item-section>

              <q-item-section>
                <q-item-label>
                  <q-skeleton type="text" width="35%" />
                </q-item-label>
                <q-item-label caption>
                  <q-skeleton type="text" />
                </q-item-label>
              </q-item-section>
            </q-item>
          </div>
        </div>

      </div>

    </div>
  </q-page>
</template>

<script>
import {
  parsed,
} from '@quasar/quasar-ui-qcalendar'
import { defineComponent, ref } from 'vue';
import {useMeta} from "quasar";
import CountryFlag from 'vue-country-flag-next'
import {useStore} from "vuex";

export default defineComponent({
  name: 'LiveTimetable',
  components: {
    CountryFlag
  },
  data () {
    return {
      title: ref(this.$i18n.t('system.loading')),
      meta_description: '',
    }
  },
  preFetch ({ store, currentRoute, previousRoute, redirect, ssrContext, urlPath, publicPath }) {
    // fetch data, validate route and optionally redirect to some other route...
    // load timetable
    return store.dispatch("show/getTimetable", {event_id: currentRoute.params.event_id, show_id: currentRoute.params.number})

    // ssrContext is available only server-side in SSR mode
  },
  computed: {
    zone() {
      if (this.timetable) {
        return this.timetable.timetable[this.$route.params.date][this.$route.params.zone]
      }
      else
        return null
    },
    eventName() {
      if (this.timetable) {
        return this.timetable.name
      }
      else
        return null
    },
    organizerName() {
      if (this.timetable) {
        return this.timetable.organizer.name
      }
      else
        return null
    },
    eventType() {
      if (this.timetable) {
        return this.timetable.type
      }
      else
        return null
    },
    eventTypeLabel() {

      if (!this.timetable)
        return null

      switch (this.timetable.type) {
        case 'cce':
          return this.$i18n.t('events.type.cce')
        case 'cso':
          return this.$i18n.t('events.type.cso')
        case 'dressage':
          return this.$i18n.t('events.type.dressage')
        case 'hunter':
          return this.$i18n.t('events.type.hunter')
        case 'derby_cross':
          return this.$i18n.t('events.type.derby_cross')
        case 'derby_eventing':
          return this.$i18n.t('events.type.derby_eventing')
        case 'crossindoor':
          return this.$i18n.t('events.type.crossindoor')
        default:
          return this.timetable.type
      }
    },
    configTemplate_mainBackground() {
      if (this.configTemplate !== null && this.configTemplate.main_color) {
        return 'hero-results-compressed-tpl-' + this.configTemplate.main_color + '.jpg'
      }

      return 'hero-results-compressed.jpg'
    }
  },
  methods: {
    capitalize(s)
    {
      return s && s[0].toUpperCase() + s.slice(1);
    },
    formatDate(dateInput) {
      const dateValue = parsed(dateInput + ' 00:00')

      let dayStr = new Intl.DateTimeFormat(this.$i18n.locale, { weekday: 'long' }).format(new Date(dateInput));

      return this.capitalize(dayStr) + ' ' + dateValue.day.toString().padStart(2, '0') + '/' + dateValue.month.toString().padStart(2, '0')  + '/' + dateValue.year.toString()

    },
    formatDateFull(dateInput) {
      const dateValue = parsed(dateInput)

      return dateValue.day.toString().padStart(2, '0') + '/' + dateValue.month.toString().padStart(2, '0')  + '/' + dateValue.year.toString() + ' ' + dateValue.hour.toString().padStart(2, '0') + ':' + dateValue.minute.toString().padStart(2, '0')
    },
    formatHour(dateInput) {
      const dateValue = parsed(dateInput)

      return dateValue.hour.toString().padStart(2, '0') + ':' + dateValue.minute.toString().padStart(2, '0')
    },
  },
  setup () {

    const $store = useStore()
    const timetable = $store.getters["show/timetableGetter"]

    const configTemplate = $store.getters["organizer/organizerTemplateGetter"]
    const customDomain = (configTemplate !== null)

    return {
      configTemplate,
      customDomain,
      timetable,
    }
  },
  created: async function () {

    this.title = this.timetable.name
    // Horaires de l'épreuve N° 33 - blalbla
    this.meta_description = this.$i18n.t('live.timetable.show') + this.timetable.show.number + ' - ' + this.timetable.show.name

    useMeta(() => {
      return {
        // whenever "title" from above changes, your meta will automatically update
        title: this.title,
        meta: {
          title: { content: this.title },
          ogTitle: { content: this.title },
          ogUrl: { content: this.$router.currentRoute._value.href },
          twitterUrl: { content: this.$router.currentRoute._value.href },
          twitterTitle: { content: this.title },
          ogDescription: { content: this.meta_description },
          twitterDescription: { content: this.meta_description },
          description: { name:'description', content: this.meta_description },
        }
      }
    })

  },
})
</script>

<style scoped>
.table-challenge  ::v-deep(tr):nth-child(even) {
  background-color: #f3f3f4;
}
.table-challenge ::v-deep(tr):nth-child(odd) {
  background-color: #fdfdfd;
}

.table-challenge ::v-deep(td) {
  border-color: transparent;
  height: 30px;
}

.hero .text-h5, .hero .text-h6 {
  color: #272727;
  font-weight: initial;
}

.hero {
  background: none;
}

.small-flag {
  margin: -0.9em -1.2em -1.3em -1.2em;
}
</style>
